import type { LegalPolicy } from "./policies";
import "./legal.css";

export function LegalContent({ policy, id, fullPage = false }: { policy: LegalPolicy; id: string; fullPage?: boolean }) {
  return <section id={id} className={`term-detail legal-content${fullPage ? " legal-content-full" : ""}`} aria-label={policy.title} tabIndex={0}>
    {policy.blocks.map((block, index) => {
      switch (block.type) {
        case "title": return <h2 key={index}>{block.text}</h2>;
        case "heading": return <h3 key={index}>{block.text}</h3>;
        case "paragraph": return <p key={index}>{block.text}</p>;
        case "list": {
          const List = block.ordered ? "ol" : "ul";
          return <List key={index}>{block.items.map((item, itemIndex) => <li key={itemIndex}>{item.text}{item.children?.length ? <ul>{item.children.map((text, childIndex) => <li key={childIndex}>{text}</li>)}</ul> : null}</li>)}</List>;
        }
        case "table": return <table key={index}><thead><tr>{block.rows[0].map((cell, cellIndex) => <th scope="col" key={cellIndex}>{cell}</th>)}</tr></thead><tbody>{block.rows.slice(1).map((row, rowIndex) => <tr key={rowIndex}>{row.map((cell, cellIndex) => <td key={cellIndex}>{cell}</td>)}</tr>)}</tbody></table>;
      }
    })}
  </section>;
}
